"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useRoomsCountSelectorProps = void 0;
var React = _interopRequireWildcard(require("react"));
var _reactRedux = require("react-redux");
var _types = require("../../../../actions/filters/types");
var _analytics = require("../../../../analytics");
var _selectors = require("../../../../selectors");
var _useActions = require("../useActions");
var _constants = require("../../../../constants");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/** Пропсы для фильтра выбора комнатности */
const useRoomsCountSelectorProps = _ref => {
  let {
    isMyHome
  } = _ref;
  const {
    roomsCount,
    errorTooltip,
    userSetArea,
    userSetRoomsCount,
    flatAreasSuggest: {
      flatAreas
    },
    estimationTarget
  } = (0, _reactRedux.useSelector)(_selectors.selectFilters);
  const {
    setRooms,
    setError,
    setArea,
    setUserRoomsCountFlag
  } = (0, _useActions.useActions)();
  const errorMessage = errorTooltip.currentErrorField === _types.ECurrentErrorField.roomsCount ? errorTooltip.errorText : '';
  const onValueChange = React.useCallback(value => {
    setRooms({
      roomsCount: value
    });
    if (!userSetRoomsCount) {
      setUserRoomsCountFlag({
        userSetRoomsCount: true
      });
    }
    if (errorMessage) {
      setError({
        currentErrorField: _types.ECurrentErrorField.roomsCount,
        errorText: ''
      });
    }
    if (flatAreas) {
      const areaFound = flatAreas.find(item => item.roomsCount === value);
      if (areaFound && !userSetArea) {
        setArea({
          area: areaFound.area
        });
      }
    }

    /** Функции аналитики отличаеются для моего дома */
    if (isMyHome) {
      (0, _analytics.trackMyHomeRoomsCountClick)({
        value,
        auto: false
      });
    } else {
      (0, _analytics.trackRoomsCountClick)(estimationTarget);
    }
  }, [errorMessage, flatAreas, setArea, setError, setRooms, userSetArea, userSetRoomsCount, estimationTarget]);
  return {
    value: roomsCount || NaN,
    onValueChange,
    errorMessage,
    values: _constants.roomsCountSelectorOptions,
    placeholder: 'Комнат'
  };
};
exports.useRoomsCountSelectorProps = useRoomsCountSelectorProps;